/**
 * Стоп по аккаунту (T5.6): чистая часть.
 *
 * Общий стоп (risk:kill_switch) и стоп аккаунта (risk:kill_switch:<funder>)
 * — разные ключи. Трейдер читает оба одним MGET и останавливает аккаунт, если
 * взведён любой; панель показывает их раздельно, иначе снятие одного
 * выглядело бы как возврат торговли, которой на деле нет.
 */

import type { AccountStatus, ServiceStatus } from "../api/types";

/**
 * Взведён ли стоп аккаунта: так считает трейдер; при его молчании — так
 * говорит наш ключ. Та же логика, что у общего стопа (isEngaged).
 */
export function accountEngaged(a: AccountStatus): boolean {
  if (a.kill_switch !== null) return a.kill_switch;
  return a.kill_switch_ui === true;
}

/** Слоты аккаунтов со взведённым стопом — для полосы под шапкой. */
export function engagedAccounts(status: ServiceStatus | undefined): string[] {
  return (status?.accounts ?? []).filter(accountEngaged).map((a) => a.slot);
}

/**
 * Можно ли снять стоп аккаунта кнопкой. Снимается только ключ, который пишет
 * web_api: взведённое трейдером по иной причине кнопка не вернёт, и обещать
 * это нельзя.
 */
export function accountReleasable(a: AccountStatus): boolean {
  return a.kill_switch_ui === true;
}
